import { Controller } from '@hotwired/stimulus'

// Marks the open conversation's row as active in the master-detail inbox.
//
// A row's subject link loads the thread into the detail frame WITHOUT changing
// the index's server render, so the list can't know which row is selected on its
// own. On click we highlight the chosen row (and clear the others) purely on the
// client — a session affordance, reset on the next full inbox load.
export default class extends Controller {
  static targets = ['row']

  select(event) {
    const chosen = event.currentTarget.closest("[data-conversation-list-target='row']")
    if (!chosen) return

    this.rowTargets.forEach((row) => {
      const active = row === chosen
      row.classList.toggle('active-thread', active)
      const link = row.querySelector('a[data-thread-link]')
      if (!link) return
      if (active) link.setAttribute('aria-current', 'true')
      else link.removeAttribute('aria-current')
    })
  }
}
